import memberService from '../services/MemberService';

export default class MessageAction {

  static getLoginMessage() {
    return memberService.getLoginMessage().then(res => {
      return res.data;
    }).catch(e => {
      return null;
    });
  }

  static readLoginMessage() {
    return memberService.readLoginMessage().then(res => {
      return res.data;
    }).catch(e => {
      return null;
    });
  }

}


// WEBPACK FOOTER //
// ./src/app/actions/MessageAction.js